import Styles from 'screens/Campaign/CampaignContext/CampaignContext.module.scss'
import { Text } from 'blaze-ui/Text/Text'
import { SourceRow } from 'screens/Campaign/CampaignContext/SourceRow'
import { Skeleton } from 'components/Skeleton/Skeleton'
import { ContextTableProps } from 'screens/Campaign/CampaignContext/Types'
import { EmptyState } from './EmptyState'

const LoadingRow = () => (
  <tr className={Styles.row}>
    <td className={Styles.cell}>
      <Skeleton active paragraph={false} title={{ style: { borderRadius: '10px', margin: 0 } }} />
    </td>
    <td className={Styles.cell}>
      <Skeleton active paragraph={false} title={{ style: { borderRadius: '10px', margin: 0 } }} />
    </td>
    <td className={Styles.cell}>
      <Skeleton active paragraph={false} title={{ style: { borderRadius: '10px', margin: 0 } }} />
    </td>
    <td className={Styles.cell} />
  </tr>
)

export const ContextTable = ({ sources, isLoading = false, onSourceCreated, onDeleteSource }: ContextTableProps) => {
  if (sources.length === 0 && !isLoading) {
    return <EmptyState onSourceCreated={onSourceCreated} />
  }

  return (
    <table className={Styles.table}>
      <colgroup>
        <col />
        <col style={{ width: '100px' }} />
        <col style={{ width: '105px' }} />
        <col style={{ width: '50px' }} />
      </colgroup>
      <thead>
        <tr>
          <th className={Styles.cellHead}>
            <Text variant="label">Name</Text>
          </th>
          <th className={Styles.cellHead}>
            <Text variant="label">File Type</Text>
          </th>
          <th className={Styles.cellHead}>
            <Text variant="label">Date Added</Text>
          </th>
          <th className={Styles.cellHead} />
        </tr>
      </thead>
      <tbody>
        {sources.map((source) => (
          <SourceRow key={source.id} source={source} onDeleteSource={onDeleteSource} />
        ))}
        {isLoading && Array.from({ length: 3 }).map((_, index) => <LoadingRow key={index} />)}
      </tbody>
    </table>
  )
}
